import styled from 'styled-components';

export default styled.div`
  position: absolute;
  overflow: hidden;
  left: 0;
  top: 30px;
  height: auto;
  width: 100%;
  z-index: 9999999;
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
`;

export const Users = styled.div`
  height: auto;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
`;
